import React from 'react'
import { observer } from 'mobx-react-lite'
import { CommonPage } from 'shared/layout/CommonPage'
import { OwnerMembersTableFeature } from 'features/owner-members/owner-members-table.feature'

// Owner-only обзор мемберов: регистрация в клубе, последний визит, текущий баланс.
export const MembersOverviewPage = observer(() => (
  <CommonPage title={<h2>Members overview</h2>}>
    <OwnerMembersTableFeature />
  </CommonPage>
))
